module.exports = __webpack_public_path__ + "static/media/sinister_type_damage.c8d213e6.svg";